"use client";

import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
}), 'SignalCellularAlt2BarTwoTone');